import Vue from "vue";
import isBefore from "date-fns/is_before";
import api from "../../services/firebase/api";

const state = {
  schedule: [],
  areas: [],
  files: [],
  fliers: [],
  footerSections: [],
  images: [],
  sponsors: [],
  themes: [],
  activeDoc: null,
  activeSubDoc: null,
  galleries: null,
};

const getters = {
  getVendorRegFile: (state) => {
    return state.files.find((file) => file.permID === "venReg");
  },
  getVendorTCFile: (state) => {
    return state.files.find((file) => file.permID === "venTC");
  },
};

const actions = {
  async fetchCollection({ commit }, { ref, collectionName }) {
    try {
      commit("flipProcessing");
      let collection = await api.fetchCollection(ref);
      collection = collection.sort((a, b) => {
        const comesBeforeB = isBefore(
          new Date(a.createdAt),
          new Date(b.createdAt)
        );
        if (comesBeforeB) {
          return -1;
        }
        return 1;
      });
      if (Object.keys(state).includes(collectionName)) {
        commit("fetchCollection", { collection, collectionName });
      }
      commit("flipProcessing", false);
    } catch (error) {
      console.log(error, "error fetching collection");
    }
  },
  async fetchDocument({ commit }, ref) {
    try {
      commit("flipProcessing");
      let doc = await api.fetchDocument(ref);
      return doc;
    } catch (error) {
      console.log(error, "error fetching document");
    }
  },
  async saveDocument({ commit, state }, { ref, collectionName, doc }) {
    try {
      commit("flipSaving");
      if (Object.keys(state.activeDoc) < 1) {
        doc = await api.create(ref, doc);
        commit("saveDocument", { doc, collectionName });
      } else {
        doc = await api.update(ref, doc);
        commit("updateDocument", { doc, collectionName });
      }
      commit("setActiveDoc", null);
      commit("setActiveSubDoc", null);
      Vue.toasted.success("Updated successfully.");
    } catch (e) {
      console.log(e);
      Vue.toasted.error("Please try again");
    } finally {
      commit("flipSaving", false);
    }
  },
  async removeDoc({ commit, state }, { ref, collectionName, doc }) {
    if (state.activeDoc && state.activeDoc === doc.id) {
      commit("setActiveDoc", null);
    }
    await api.remove(ref);
    console.log("removed");
    commit("removeDoc", { collectionName, doc });
  },
  async setActiveDoc({ commit }, doc) {
    commit("setActiveDoc", { ...doc });
  },
  async setActiveSubDoc({ commit }, doc) {
    commit("setActiveSubDoc", { ...doc });
  },
};

const mutations = {
  fetchCollection(state, { collection, collectionName }) {
    state[collectionName] = collection;
  },
  saveDocument(state, { doc, collectionName }) {
    state[collectionName].push(doc);
  },
  updateDocument(state, { doc, collectionName }) {
    const index = state[collectionName].findIndex((item) => item.id === doc.id);
    state[collectionName].splice(index, 1, doc);
  },
  removeDoc(state, { doc, collectionName }) {
    const index = state[collectionName].findIndex((item) => item.id === doc.id);
    state[collectionName].splice(index, 1);
  },
  setActiveDoc(state, doc) {
    state.activeDoc = doc;
  },
  setActiveSubDoc(state, doc) {
    state.activeSubDoc = doc;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
